<template>
  <v-tabs height="55" hide-slider class="base-card elevation-0 lightGrey2" center-active show-arrows background-color="transparent">
    <v-tab v-for="(tab, i) in tabs" :key="i" class="ui-tab mx-2 black--text" active-class="base-card white" :to="tab.to">
      <span class="btn-text">{{ tab.text }}</span>
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'Tabs',

  props: {
    tabs: {
      type: Array,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-tab {
  margin: 6px;
}

.ui-tab:before, .ui-tab:hover:before {
  border-radius: 8px !important;
  background: transparent !important;
}

.ui-tab:hover:before {
  border-radius: 8px !important;
  opacity: 0;
}

.ui-tab:hover:active {
  border-radius: 8px !important;
}
</style>
